/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { notEmpty } from '@ember/object/computed';
import FormCondition from 'cio/app-models/conditions/form';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import { all, any } from 'cio/app-models/conditions/group';
import CustomFormsService from 'cio/services/custom-forms';
import { FormType } from 'cio/utils/forms';
import { tagName } from '@ember-decorators/component';
import CioConditionViewerBase, { CioConditionViewerBaseArgs } from 'cio/components/cio-condition-viewer-base';

interface CioConditionViewerFormArgs extends CioConditionViewerBaseArgs {
  condition: FormCondition;
  labelTruncate?: boolean;
}

const GROUP_TYPES = {
  [all]: 'all',
  [any]: 'at least one',
};

@tagName('')
export default class CioConditionViewerForm extends CioConditionViewerBase<CioConditionViewerFormArgs> {
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service customForms!: CustomFormsService;

  readonly FormType = FormType;

  @notEmpty('args.condition.filters') hasFilter!: boolean;

  @computed('args.condition.filterOperator')
  get filterOperator() {
    return GROUP_TYPES[this.args.condition.filterOperator];
  }

  @computed('facebookLeadAds.forms.[]', 'customForms.forms.[]', 'args.condition.formID')
  get form() {
    let { formID, formType } = this.args.condition;
    if (formType === FormType.FacebookLeadAds) {
      return this.facebookLeadAds.forms.findBy('formId', formID);
    }

    return this.customForms.forms.findBy('formIdLowercase', formID);
  }

  constructor(owner: unknown, args: CioConditionViewerFormArgs) {
    super(owner, args);

    this.facebookLeadAds.initialize();
    this.customForms.initialize();
  }
}
